export default __webpack_public_path__ + "static/media/conspiration-a-la-reine_.2d816a65.jpg";